import { colors, Icons } from 'bold-ui'
import { AcompanhamentoPreNatalStatusExameEnum, TrimestreGestacional } from 'graphql/types.generated'

import { CategoriaImcReferenciaEnum } from '../../components/modals/medicoes/graficos/pre-natal/ganho-peso/model-graficoGanhoPeso'

export interface MedicaoField<T> {
  medicao: T
  dataMedicao: string
}

export interface MedicoesAcompanhamentoPreNatal {
  alturaUterina?: MedicaoField<string>
  peso?: MedicaoField<number | string>
  batimentoCardiacoFetal?: MedicaoField<string>
  batimentoCardiacoFetal2?: MedicaoField<string>
  edema?: MedicaoField<string>
  movimentacaoFetal?: MedicaoField<boolean>
  pressaoArterial?: MedicaoField<string>
  glicemiaCapilar?: MedicaoField<string>
}

export const MEDICOES_ACOMPANHAMENTO_PRE_NATAL: Array<keyof MedicoesAcompanhamentoPreNatal> = [
  'alturaUterina',
  'peso',
  'batimentoCardiacoFetal',
  'batimentoCardiacoFetal2',
  'edema',
  'movimentacaoFetal',
  'pressaoArterial',
  'glicemiaCapilar',
]

enum IntervaloPercentilEnum {
  ABAIXO_P10 = 'Abaixo de P10',
  P10_P18 = 'P10-P18',
  P10_P27 = 'P10-P27',
  P10_P34 = 'P10-P34',
  P18_P27 = 'P18-P27',
  P18_P34 = 'P18-P34',
  P27_P38 = 'P27-P38',
  P27_P50 = 'P27-P50',
  P34_P50 = 'P34-P50',
  P38_P50 = 'P38-P50',
  P50_P90 = 'P50-P90',
  ACIMA_P90 = 'Acima de P90',
}

export const statusExamePreNatalRecord: Record<
  AcompanhamentoPreNatalStatusExameEnum,
  { color: string; icon: Icons; label: string }
> = {
  RESULTADO_ANTERIOR: { color: colors.turquoise.c40, icon: 'undo', label: 'Resultado anterior' },
  RESULTADO: { color: colors.green.c40, icon: 'checkCircleOutline', label: 'Resultado' },
  SOLICITADO: { color: colors.blue.c40, icon: 'infoCircleOutline', label: 'Solicitado' },
  NAO_SOLICITADO: { color: colors.red.c40, icon: 'timesOutline', label: 'Não solicitado' },
}

export const trimestreGestacionalRecord: Record<TrimestreGestacional, string> = {
  PRIMEIRO_TRIMESTRE: '1º Trimestre',
  SEGUNDO_TRIMESTRE: '2º Trimestre',
  TERCEIRO_TRIMESTRE: '3º Trimestre',
  FORA_PERIODO: 'Fora do período gestacional',
}

export const PERCENTIS_POR_CATEGORIA: Record<CategoriaImcReferenciaEnum, string[]> = {
  [CategoriaImcReferenciaEnum.BAIXO_PESO]: [
    IntervaloPercentilEnum.ABAIXO_P10,
    IntervaloPercentilEnum.P10_P18,
    IntervaloPercentilEnum.P18_P34,
    IntervaloPercentilEnum.P34_P50,
    IntervaloPercentilEnum.P50_P90,
    IntervaloPercentilEnum.ACIMA_P90,
  ],
  [CategoriaImcReferenciaEnum.EUTROFIA]: [
    IntervaloPercentilEnum.ABAIXO_P10,
    IntervaloPercentilEnum.P10_P34,
    IntervaloPercentilEnum.P34_P50,
    IntervaloPercentilEnum.P50_P90,
    IntervaloPercentilEnum.ACIMA_P90,
  ],
  [CategoriaImcReferenciaEnum.SOBREPESO]: [
    IntervaloPercentilEnum.ABAIXO_P10,
    IntervaloPercentilEnum.P10_P18,
    IntervaloPercentilEnum.P18_P27,
    IntervaloPercentilEnum.P27_P50,
    IntervaloPercentilEnum.P50_P90,
    IntervaloPercentilEnum.ACIMA_P90,
  ],
  [CategoriaImcReferenciaEnum.OBESIDADE]: [
    IntervaloPercentilEnum.ABAIXO_P10,
    IntervaloPercentilEnum.P10_P27,
    IntervaloPercentilEnum.P27_P38,
    IntervaloPercentilEnum.P38_P50,
    IntervaloPercentilEnum.P50_P90,
    IntervaloPercentilEnum.ACIMA_P90,
  ],
}
